import apiClient from "./apiClient";

const blogsEndpoint = "/blogs";

// Obtener todos los blogs
export const getAllBlogs = async () =>
  apiClient.get(`${blogsEndpoint}/getAll`).then((res) => res.data);

// Crear un nuevo blog (recibe FormData)
export const createBlog = async (data) =>
  apiClient.post(`${blogsEndpoint}/create`, data).then((res) => res.data);

// Actualizar un blog existente (recibe ID y FormData)
export const updateBlog = async (id, data) =>
  apiClient
    .patch(`${blogsEndpoint}/update/${id}`, data)
    .then((res) => res.data);

// Eliminar un blog
export const deleteBlog = async (id) =>
  apiClient.delete(`${blogsEndpoint}/delete/${id}`).then((res) => res.data);
